export enum NotificationStatus {
    SEND = 'send',
    SCHEDULE = 'schedule',
  }
  
  export enum NotificationDevice {
    IOS = 'ios',
    ANDROID = 'android',
    ALL = 'all',
    WEB = 'web'
  }
  
  export enum UserType {
    ALL = 'all',
    BUILDER = 'builder',
    BROKER = 'broker',
    SELF = 'self'
  }

  export enum NotificationType {
    SYSTEM = 'system',
    OTHER = 'other',
    ALERT = 'alert',
    INFO = 'info',
    WARNING = 'warning',
    ERROR = 'error',
    SUCCESS = 'success',
    CRITICAL = 'critical',
    HIGH = 'high',
    MEDIUM = 'medium',
    LOW = 'low',
  }